import { useQueries } from '@tanstack/react-query';
import apiQueryOptions from './apiQueryOptions';

/**
 * useQueries wired to apiRequest, for endpoints that have to be fanned out over a
 * runtime-length list (one call per agency, per file, ...). a hook cannot be called
 * in a loop, so this is the one shape useApiQuery structurally cannot express: each
 * entry keeps its own cache slot, retry budget and error state, which is what lets a
 * caller retry just the agencies that failed.
 * @param entries - one { queryKey, request, parse, options } per parallel call
 * @param sharedOptions - useQuery options merged into every entry
 */
export default function useApiQueries(entries, sharedOptions = {}) {
  return useQueries({
    queries: (entries ?? []).map(({ queryKey, request, parse, options }) => ({
      ...apiQueryOptions({ queryKey, request, parse }),
      ...sharedOptions,
      ...options
    }))
  });
}
